import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Row, Col, ListGroup, Card, Form } from 'react-bootstrap';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { FaLayerGroup, FaChevronRight, FaBolt, FaCogs, FaLink, FaFilter } from 'react-icons/fa';

import Product from '../components/Product';
import Loader from '../components/Loader';
import Message from '../components/Message';
import Paginate from '../components/Paginate';
import ProductCarousel from '../components/ProductCarousel';
import { useGetProductsQuery, useGetProductFiltersQuery } from '../slices/productsApiSlice';

const HomeScreen = () => {
  const { userInfo } = useSelector((state) => state.auth);
  const { userDiscount } = useSelector((state) => state.discount);
  const { pageNumber, keyword } = useParams();
  const navigate = useNavigate();

  // 🌟 REVIZYON: Çoklu marka ve çoklu akım seçimlerini hafızada tutan dinamik diziler
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [selectedCurrents, setSelectedCurrents] = useState([]);

  // 🌟 REVIZYON: Çoklu seçimleri backend'in ($in) anlayacağı şekilde virgüllü metne paketliyoruz
  // AYIRICI OLARAK "," DEĞİL "|" KULLANILIYOR: kesit değerleri Türkçe ondalık ayracı
  // olarak virgül içeriyor (ör. "10x1,5 mm²") - virgülle ayrılan bir listede bu değer
  // "10x1" ve "5 mm²" diye ikiye bölünüp DB'deki tam değerle eşleşmiyordu.
  const brandsParam = selectedBrands.length > 0 ? selectedBrands.join('|') : '';
  const currentsParam = selectedCurrents.length > 0 ? selectedCurrents.join('|') : '';

  // API Sorgusu - Tüm çoklu filtre parametreleri sunucuya fırlatılır
  const { data, isLoading, error } = useGetProductsQuery({ 
    keyword, 
    pageNumber, 
    brands: brandsParam,
    currents: currentsParam 
  });

  const [tempData, setData] = useState({ products: [], page: 1, pages: 1 });
  const [change, setChange] = useState(false);

  // Kategori Listeleri (Sol Panel Akışı)
  const mainCategories = [
    { id: 'Şalt Malzemeleri', name: 'Şalt Malzemeleri', icon: <FaBolt className="text-warning me-2" /> },
    { id: 'Otomasyon', name: 'Otomasyon', icon: <FaCogs className="text-info me-2" /> },
    { id: 'Kablo', name: 'Kablo', icon: <FaLink className="text-success me-2" /> }
  ];
  
  const saltCategories = [
    { id: 'Sigorta', name: 'Sigorta Ürünleri' },
    { id: 'Motor Koruma Şalteri', name: 'Motor Koruma Şalterleri' },
    { id: 'Kontaktör', name: 'Kontaktör Grubu' },
    { id: 'Şalter', name: 'Kompakt Şalterler' },
    { id: 'Röle', name: 'Kaçak Akım Röleleri' }
  ];

  const otomasyonCategories = [
    { id: 'AC Sürücü', name: 'AC Sürücüler' },
    { id: 'Servo Sürücü', name: 'Servo Sürücüler' },
    { id: 'PLC', name: 'PLC Sistemleri' },
    { id: 'HMI', name: 'HMI Paneller' }
  ];

  // id'ler doğrudan MongoDB'deki category alanıyla birebir eşleşiyor (starakim.com
  // kablo kazımasında bu isimlerle yazılıyor) - backend artık keyword aramasını hem
  // description hem category alanında yaptığı için bu tam eşleşme doğru ürünleri getirir.
  const kabloCategories = [
    { id: 'Sinyal ve Kontrol Kabloları', name: 'Sinyal ve Kontrol Kabloları' },
    { id: 'Kumanda Kablosu', name: 'Kumanda Kabloları' }
  ];

  const getSidebarData = () => {
    const isSaltContext = saltCategories.some(c => c.id === keyword) || keyword?.toLowerCase().includes('şalt');
    const isOtomasyonContext = otomasyonCategories.some(c => c.id === keyword) || keyword?.toLowerCase().includes('otomasyon');
    const isKabloContext = kabloCategories.some(c => c.id === keyword) || keyword?.toLowerCase().includes('kablo');
    if (!keyword) return { title: 'Tüm Kategoriler', icon: <FaLayerGroup className="text-info me-2" />, list: mainCategories, isMain: true };
    if (isSaltContext) return { title: 'Şalt Malzemeleri', icon: <FaBolt className="text-warning me-2" />, list: saltCategories, currentLabel: 'Anma Akımı' };
    if (isOtomasyonContext) return { title: 'Otomasyon', icon: <FaCogs className="text-info me-2" />, list: otomasyonCategories, currentLabel: 'Anma Akımı' };
    if (isKabloContext) return { title: 'Kablolar', icon: <FaLink className="text-success me-2" />, list: kabloCategories, currentLabel: 'Kesit' };
    return { title: 'Şalt Malzemeleri', icon: <FaBolt className="text-warning me-2" />, list: saltCategories, currentLabel: 'Anma Akımı' };
  };

  const sidebarData = getSidebarData();

  const handleSubCategoryClick = (catName) => navigate(`/search/${encodeURIComponent(catName)}`);

  // 🌟 HATA DÜZELTİLDİ: Kategori (keyword) değiştiğinde önceki kategoriden kalan marka/akım
  // filtreleri otomatik temizlenir. Aksi halde bir kategoride seçilen filtre başka bir
  // kategoride hiçbir ürünle eşleşmediğinde "ürün bulunamadı" durumu kalıcı hale geliyordu
  // (HomeScreen route değişiminde yeniden mount olmadığı için state kalıcı kalıyordu).
  useEffect(() => {
    setSelectedBrands([]);
    setSelectedCurrents([]);
  }, [keyword]);

  // 🌟 REVIZYON: Çoklu marka seçimini (ekleme/çıkarma) yöneten fonksiyon
   // 🌟 KESİN ÇÖZÜM: Birden fazla markanın aynı anda seçili kalmasını sağlayan çoklu dizi yönetimi
  const handleBrandChange = (brandName) => {
    const target = brandName.toLowerCase().trim();
    
    // Eğer tıklanan marka zaten seçili markalar dizisinde varsa (kullanıcı tiki kaldırıyorsa)
    if (selectedBrands.includes(target)) {
      // O markayı filtreleyerek diziden çıkartıyoruz
      setSelectedBrands(selectedBrands.filter(b => b !== target));
    } else {
      // 🌟 KRİTİK ALAN: Eğer dizide yoksa, ESKİ SEÇİLİ MARKALARI KORU (...selectedBrands) ve yanına YENİSİNİ ekle
      setSelectedBrands([...selectedBrands, target]);
    }
  };


  // 🌟 REVIZYON: Çoklu anma akımı seçimini (ekleme/çıkarma) yöneten fonksiyon
  const handleCurrentChange = (currentValue) => {
    if (selectedCurrents.includes(currentValue)) {
      setSelectedCurrents(selectedCurrents.filter(c => c !== currentValue));
    } else {
      setSelectedCurrents([...selectedCurrents, currentValue]);
    }
  };

  // 🌟 HATA DÜZELTİLDİ: Markalar/Anma Akımı listesi artık SADECE o anki 12 ürünlük
  // sayfadan değil, keyword'e uyan TÜM ürünlerden (ayrı bir /api/products/filters
  // sorgusuyla) geliyor. Öncesinde ilk sayfadaki ürünler tesadüfen hep aynı markaysa
  // (ör. hepsi Siemens), filtre panelinde diğer markalar (Schneider, Viko, Günsan vb.)
  // hiç görünmüyordu.
  const { data: filterData } = useGetProductFiltersQuery({ keyword });

  // 🌟 REVIZYON: Markaların arayüzde mükerrer (Siemens ve SIEMENS olarak) çıkmasını engeller
  const dynamicBrandList = (() => {
    if (!filterData || !filterData.brands) return [];

    const brands = filterData.brands
      .filter(b => b && b.trim() !== '')
      .map(b => b.trim()); // Başındaki ve sonundaki boşlukları siler

    // Hepsini Set'e atmadan önce ilk harfi büyük, kalanları küçük olacak şekilde (Örn: Siemens, Schneider) standartlaştırıyoruz
    const capitalizedBrands = brands.map(b => b.charAt(0).toUpperCase() + b.slice(1).toLowerCase());

    return [...new Set(capitalizedBrands)].sort((a, b) => a.localeCompare(b));
  })();

  // 🌟 REVIZYON: Gelen ürün listesinden dinamik akımları ayıklayan Set kurgusu
  const dynamicCurrentList = (() => {
    if (!filterData || !filterData.currents) return [];
    return [...new Set(filterData.currents)].sort((a, b) => parseFloat(a) - parseFloat(b));
  })();

  useEffect(() => {
    if (data) {
      if (userInfo && userInfo.discountItems && Array.isArray(userInfo.discountItems)) {
        const processedProducts = data.products.map((product) => {
          const brandDiscount = userInfo.discountItems.find(
            (d) => d && d.brand && d.brand.toLowerCase() === product.brand?.toLowerCase()
          );

          if (brandDiscount && brandDiscount.categories) {
            const categoryDiscount = brandDiscount.categories.find(
              (c) => c && c.category && c.category.toLowerCase() === product.category?.toLowerCase()
            );

            if (categoryDiscount) {
              const discountRate = categoryDiscount.discount || 0;
              return {
                ...product,
                extraDiscount: discountRate,
                discountPrice: (product.price - product.price * (discountRate / 100)).toFixed(2),
                priceShow: brandDiscount.priceShow,
                extraDiscountShow: brandDiscount.extraDiscountShow,
              };
            }
          }
          return product;
        });

        setData({
          page: data.page,
          pages: data.pages,
          products: processedProducts,
        });
      } else {
        setData(data);
      }
      setChange(true);
    }
    // 🌟 DÜZELTİLDİ: Çoklu seçimlerde listenin anlık yenilenmesi için filtre dizileri bağımlılıklara eklendi
  }, [data, userInfo, userDiscount, selectedBrands, selectedCurrents]);

  return (
    <>
      {!keyword ? <ProductCarousel /> : <Link to="/" className="btn btn-light mb-4">Geri dön</Link>}
      {isLoading ? (
        <Loader />
      ) : error ? (
        <Message variant="danger">{error?.data?.message || error?.error || 'Hata oluştu'}</Message>
      ) : (
        (tempData || data) && change && (
          <Row className="mt-3">
            <Col lg={2} md={3} sm={12} className="mb-4">
              <Card className='my-1 p-2 rounded d-flex flex-column h-100'>
                <Card.Header className="bg-dark text-white py-3 fw-bold d-flex align-items-center" style={{ fontSize: '0.88rem' }}>
                  {sidebarData.icon} {sidebarData.title.toUpperCase()}
                </Card.Header>
                <ListGroup variant="flush">
                  {sidebarData.list.map((sub) => {
                    const isActive = keyword === sub.id;
                    return (
                      <ListGroup.Item 
                        key={sub.id} 
                        action 
                        onClick={() => handleSubCategoryClick(sub.id)}
                        className="d-flex align-items-center justify-content-between"
                        style={{ fontSize: '0.82rem', fontWeight: isActive ? '700' : '500', color: isActive ? '#66CCFF' : '#333' }}
                      >
                        <span>{sub.name}</span>
                        <FaChevronRight style={{ fontSize: '0.65rem' }} />
                      </ListGroup.Item>
                    );
                  })}
                </ListGroup>
                
                {!sidebarData.isMain && (
                  <>
                                  {/* MARKALAR PANELİ */}
                    {dynamicBrandList.length > 0 && (
                      <Card className="border-0 shadow-sm rounded mt-3">
                        <Card.Header className="bg-white text-dark py-2.5 fw-bold border-bottom" style={{ fontSize: '0.82rem' }}>
                          <FaFilter className="me-2" /> Markalar
                        </Card.Header>
                        <Card.Body className="py-2 px-3" style={{ maxHeight: '180px', overflowY: 'auto' }}>
                          <Form>
                            {dynamicBrandList.map((brandName, idx) => {
                              // 🌟 HATA DÜZELTİLDİ: Karşılaştırma yaparken iki tarafı da tamamen küçük harfe eşitliyoruz
                              const isChecked = selectedBrands.includes(brandName.toLowerCase().trim());
                              
                              return (
                                <Form.Check 
                                  key={idx}
                                  type="checkbox"
                                  id={`brand-${idx}`}
                                  label={brandName} // Ekranda nizami görünür (Örn: Siemens)
                                  checked={isChecked} // 🌟 Hafızadaki durumla tam eşleşme sağlandı
                                  // 🌟 HATA DÜZELTİLDİ: Değişim fonksiyonuna harf çakışması olmaması için direkt küçük harf halini yolluyoruz
                                  onChange={() => handleBrandChange(brandName.toLowerCase().trim())}
                                  style={{ fontSize: '0.8rem', fontWeight: '500', color: '#444' }}
                                  className="py-1"
                                />
                              );
                            })}
                          </Form>
                        </Card.Body>
                      </Card>
                    )}


                    {/* 🌟 REVIZYON: Seçili markaların altındaki akım değerlerini listeleyen dinamik panel */}
                    {dynamicCurrentList.length > 0 && (
                      <Card className="border-0 shadow-sm rounded mt-3">
                        <Card.Header className="bg-white text-dark py-2.5 fw-bold border-bottom" style={{ fontSize: '0.82rem' }}>
                          <FaFilter className="me-2" /> {sidebarData.currentLabel || 'Anma Akımı'}
                        </Card.Header>
                        <Card.Body className="py-2 px-3" style={{ maxHeight: '220px', overflowY: 'auto' }}>
                          <Form>
                            {dynamicCurrentList.map((currentValue, idx) => (
                              <Form.Check 
                                key={idx}
                                type="checkbox"
                                id={`current-${idx}`}
                                label={currentValue}
                                checked={selectedCurrents.includes(currentValue)}
                                onChange={() => handleCurrentChange(currentValue)}
                                style={{ fontSize: '0.8rem', fontWeight: '500', color: '#444' }}
                                className="py-1"
                              />
                            ))}
                          </Form>
                        </Card.Body>
                      </Card>
                    )}
                  </>
                )}
              </Card>
            </Col>
            
            <Col lg={10} md={9} sm={12}>
              {!keyword ? (
                <h1 className="mb-3" style={{ fontSize: '1.4rem', fontWeight: 'bold' }}>Öne Çıkan Ürünler</h1>
              ) : (
                <h3 className="mb-3" style={{ fontSize: '1.2rem' }}> 
                  "{keyword}" için arama sonuçları 
                  {selectedBrands.length > 0 && ` (${selectedBrands.join(', ').toUpperCase()})`}
                  {selectedCurrents.length > 0 && ` - ${(sidebarData.currentLabel || 'Anma Akımı').toUpperCase()}: (${selectedCurrents.join(', ')})`}
                </h3>
              )}
              
              <Row className="g-2">
                {/* Veritabanından gelen tam kapasiteli 12 ürün listelenir */}
                {(userInfo ? tempData?.products : data?.products)?.map((product) => (
                  <Col key={product._id} xs={6} sm={6} md={4} lg={3} xl={3}>
                    <Product product={product} />
                  </Col>
                ))}
                
                {(userInfo ? tempData?.products : data?.products)?.length === 0 && (
                  <Col xs={12} className="text-center mt-5">
                    <Message variant="info">Seçili filtre kriterlerine uyan ürün bulunamadı.</Message>
                  </Col>
                )}
              </Row>

              <div className="mt-4">
                <Paginate
                  pages={userInfo ? tempData?.pages : data?.pages}
                  page={userInfo ? tempData?.page : data?.page}
                  keyword={keyword ? keyword : ''}
                />
              </div>
            </Col>
          </Row>
        )
      )}
    </>
  );
};

export default HomeScreen;
